import React, { useState } from 'react';

export const DownloadMergeScript: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDownload = () => {
    // Read the merge script content
    fetch('/scripts/vehicle_merge_generator.lua')
      .then(response => response.text())
      .then(content => {
        // Create a blob and download
        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'vehicle_merge_generator.lua';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Failed to download merge script:', error);
      });
  };

  return (
    <div className="merge-script-container">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="download-merge-btn"
        title="Download script for split vehicle files"
      >
        <span>📥 Vehicle Merge Script</span>
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>
      
      {isOpen && (
        <div className="merge-script-dropdown">
          <div className="merge-script-info">
            <h4>About This Script</h4>
            <p className="important-note">
              ⚠️ <strong>This is NOT needed</strong> if you have the original 
              <code>vehicles.lua</code> file format from qbx_core.
            </p>
            <p>
              Only download this if your <code>vehicles.lua</code> is split into 
              multiple files and cannot be loaded directly.
            </p>
            <div className="usage-steps">
              <h5>Usage:</h5>
              <ol>
                <li>Place script in qbx_core root folder</li>
                <li>Add to fxmanifest.lua server_scripts</li>
                <li>Restart server</li>
                <li>Run <code>/mergevehicles</code> command</li>
                <li>Load generated <code>merged_vehicles.lua</code> here</li>
              </ol>
            </div>
            <button onClick={handleDownload} className="download-btn">
              Download Script
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
